import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";

const Menu = () => {
  const location = useLocation();
  const { pathname } = location;

  const splitLocation = pathname.split("/");
  console.log(splitLocation[0]);
  return (
    <header>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" fixed="top">
        <Navbar.Brand as={Link} to="/">
          DARE
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end"
        >
          <Nav>
            <Nav.Link
              eventKey="homeLink"
              as={Link}
              to="/"
              className={splitLocation[1] === "" ? "currently-active" : ""}
            >
              Home
            </Nav.Link>
            <Nav.Link
              eventKey="aboutLink"
              as={Link}
              to="/about"
              className={splitLocation[1] === "about" ? "currently-active" : ""}
            >
              About
            </Nav.Link>
            <Nav.Link
              eventKey="portfolioLink"
              as={Link}
              to="/portfolio"
              className={
                splitLocation[1] === "portfolio" ? "currently-active" : ""
              }
            >
              Portfolio
            </Nav.Link>
            <Nav.Link
              eventKey="contactLink"
              as={Link}
              to="/contact"
              className={
                splitLocation[1] === "contact" ? "currently-active" : ""
              }
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Menu;
